module.exports = __webpack_public_path__ + "img/newsImg3-6.776e9b31.png";